import { render, staticRenderFns } from "./TouchReservationTicket.vue?vue&type=template&id=1c622a30&scoped=true&"
import script from "./TouchReservationTicket.vue?vue&type=script&lang=js&"
export * from "./TouchReservationTicket.vue?vue&type=script&lang=js&"
import style0 from "./TouchReservationTicket.vue?vue&type=style&index=0&id=1c622a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c622a30",
  null
  
)

export default component.exports